// ─────────────────────────────────────────────────────────────────────────────
// ⚠️ LEGACY — ESQUEMA DE FASES v1. NO USAR PARA WORKFLOW NUEVO.
//
// Esta enumeración tiene DOCE fases e inserta "Propuesta aceptada" en el índice 2,
// una fase que la enumeración canónica no tiene. Desde ahí todo corre un lugar:
// el mismo entero que aquí es "Brief" (5) allá es "Reunión". Durante meses ambas
// convivieron leyendo la MISMA columna `clientes.stage`, y por eso un 5 significaba
// tres cosas a la vez según qué módulo lo mirara.
//
// LA FUENTE CANÓNICA ES `src/lib/etapasFeria.js`. Además, la fase real pertenece
// al PROYECTO y se DERIVA de hechos (`deriveProjectStage`), no a un entero por
// cliente que alguien empuja con un botón.
//
// Esto sobrevive para UNA sola cosa: interpretar la historia anterior al corte
// —las filas de `crm_stage_transitions` con `stage_schema_version = 1`— y sostener
// a sus consumidores actuales mientras se repuntan. No agregar usos nuevos.
// ─────────────────────────────────────────────────────────────────────────────

export const CRM_PHASE_IDS = Object.freeze({
  F0: 'F0',
  F1: 'F1',
  F2: 'F2',
  F3: 'F3',
  F4: 'F4',
  F5: 'F5',
  F6: 'F6',
  F7: 'F7',
  F8: 'F8',
  F9: 'F9',
  F10: 'F10',
  F11: 'F11',
});

export const CRM_PHASES = Object.freeze({
  [CRM_PHASE_IDS.F0]: {
    id: CRM_PHASE_IDS.F0,
    index: 0,
    label: 'Captacion',
    description: 'Lead o contacto inicial registrado; aun no existe propuesta formal.',
  },
  [CRM_PHASE_IDS.F1]: {
    id: CRM_PHASE_IDS.F1,
    index: 1,
    label: 'Propuesta enviada',
    description: 'La cotizacion fue preparada y compartida con el cliente.',
  },
  [CRM_PHASE_IDS.F2]: {
    id: CRM_PHASE_IDS.F2,
    index: 2,
    label: 'Propuesta aceptada',
    description: 'El cliente acepto la propuesta y el estudio prepara el inicio.',
  },
  [CRM_PHASE_IDS.F3]: {
    id: CRM_PHASE_IDS.F3,
    index: 3,
    label: 'Contrato enviado',
    description: 'Contrato preparado y enviado para revision o firma.',
  },
  [CRM_PHASE_IDS.F4]: {
    id: CRM_PHASE_IDS.F4,
    index: 4,
    label: 'Cobro 60%',
    description: 'Anticipo inicial pendiente, enviado o confirmado segun el cobro vinculado.',
  },
  [CRM_PHASE_IDS.F5]: {
    id: CRM_PHASE_IDS.F5,
    index: 5,
    label: 'Brief',
    description: 'Portal y brief operativo habilitados para que el cliente complete informacion.',
  },
  [CRM_PHASE_IDS.F6]: {
    id: CRM_PHASE_IDS.F6,
    index: 6,
    label: 'Reunion',
    description: 'Reunion de arranque, revision o alineacion habilitada/agendada.',
  },
  [CRM_PHASE_IDS.F7]: {
    id: CRM_PHASE_IDS.F7,
    index: 7,
    label: 'Produccion',
    description: 'El proyecto esta en ejecucion interna por el equipo creativo.',
  },
  [CRM_PHASE_IDS.F8]: {
    id: CRM_PHASE_IDS.F8,
    index: 8,
    label: 'Aprobacion',
    description: 'El cliente revisa presentaciones, aprueba o solicita ajustes.',
  },
  [CRM_PHASE_IDS.F9]: {
    id: CRM_PHASE_IDS.F9,
    index: 9,
    label: 'Cobro 40%',
    description: 'Saldo final activado antes de liberar entrega final controlada.',
  },
  [CRM_PHASE_IDS.F10]: {
    id: CRM_PHASE_IDS.F10,
    index: 10,
    label: 'Brand Kit',
    description: 'Entrega final, Brand Kit o activos finales listos para el cliente.',
  },
  [CRM_PHASE_IDS.F11]: {
    id: CRM_PHASE_IDS.F11,
    index: 11,
    label: 'Post-venta',
    description: 'Seguimiento posterior, satisfaccion, testimonio, referidos y mantenimiento.',
  },
});

export const CRM_PHASE_LIST = Object.freeze(
  Object.values(CRM_PHASES).sort((a, b) => a.index - b.index)
);

export const CRM_PHASE_BY_INDEX = Object.freeze(
  CRM_PHASE_LIST.reduce((acc, phase) => {
    acc[phase.index] = phase;
    return acc;
  }, {})
);

export const CRM_ALLOWED_TRANSITIONS = Object.freeze({
  [CRM_PHASE_IDS.F0]: [CRM_PHASE_IDS.F1],
  [CRM_PHASE_IDS.F1]: [CRM_PHASE_IDS.F2],
  [CRM_PHASE_IDS.F2]: [CRM_PHASE_IDS.F3],
  [CRM_PHASE_IDS.F3]: [CRM_PHASE_IDS.F4],
  [CRM_PHASE_IDS.F4]: [CRM_PHASE_IDS.F5],
  [CRM_PHASE_IDS.F5]: [CRM_PHASE_IDS.F6],
  [CRM_PHASE_IDS.F6]: [CRM_PHASE_IDS.F7],
  [CRM_PHASE_IDS.F7]: [CRM_PHASE_IDS.F8],
  [CRM_PHASE_IDS.F8]: [CRM_PHASE_IDS.F9],
  [CRM_PHASE_IDS.F9]: [CRM_PHASE_IDS.F10],
  [CRM_PHASE_IDS.F10]: [CRM_PHASE_IDS.F11],
  [CRM_PHASE_IDS.F11]: [],
});

export const CRM_TRANSITION_TRIGGERS = Object.freeze({
  [CRM_PHASE_IDS.F0]: {
    phase: CRM_PHASE_IDS.F0,
    whatsapp_template: null,
    email_template: null,
    internal_notification: 'Lead registrado en captacion.',
  },
  [CRM_PHASE_IDS.F1]: {
    phase: CRM_PHASE_IDS.F1,
    whatsapp_template: 'quotes_whatsapp',
    email_template: 'quotes_email',
    internal_notification: 'Propuesta enviada al cliente.',
  },
  [CRM_PHASE_IDS.F2]: {
    phase: CRM_PHASE_IDS.F2,
    whatsapp_template: 'quote_accepted_whatsapp',
    email_template: 'quote_accepted_email',
    internal_notification: 'Propuesta aceptada; preparar inicio del proyecto.',
  },
  [CRM_PHASE_IDS.F3]: {
    phase: CRM_PHASE_IDS.F3,
    whatsapp_template: 'contract_sent_whatsapp',
    email_template: 'contract_sent_email',
    internal_notification: 'Contrato enviado para revision y firma.',
  },
  [CRM_PHASE_IDS.F4]: {
    phase: CRM_PHASE_IDS.F4,
    whatsapp_template: 'payment_instructions_whatsapp',
    email_template: 'payment_instructions_email',
    internal_notification: 'Anticipo 60% activado o confirmado; revisar cobro inicial.',
  },
  [CRM_PHASE_IDS.F5]: {
    phase: CRM_PHASE_IDS.F5,
    whatsapp_template: 'portal_access_whatsapp',
    email_template: 'portal_access_email',
    internal_notification: 'Portal privado y brief habilitados para el cliente.',
  },
  [CRM_PHASE_IDS.F6]: {
    phase: CRM_PHASE_IDS.F6,
    whatsapp_template: 'meeting_invite_whatsapp',
    email_template: 'meeting_invite_email',
    internal_notification: 'Reunion habilitada o agendada con el cliente.',
  },
  [CRM_PHASE_IDS.F7]: {
    phase: CRM_PHASE_IDS.F7,
    whatsapp_template: 'project_brief_completed_whatsapp',
    email_template: 'project_brief_completed_email',
    internal_notification: 'Proyecto listo para iniciar produccion interna.',
  },
  [CRM_PHASE_IDS.F8]: {
    phase: CRM_PHASE_IDS.F8,
    whatsapp_template: 'project_approval_ready_whatsapp',
    email_template: 'project_approval_ready_email',
    internal_notification: 'Presentacion lista para aprobacion o ajustes del cliente.',
  },
  [CRM_PHASE_IDS.F9]: {
    phase: CRM_PHASE_IDS.F9,
    whatsapp_template: 'project_final_payment_whatsapp',
    email_template: 'project_final_payment_email',
    internal_notification: 'Saldo final 40% activado antes de entrega final.',
  },
  [CRM_PHASE_IDS.F10]: {
    phase: CRM_PHASE_IDS.F10,
    whatsapp_template: 'project_brandkit_released_whatsapp',
    email_template: 'project_brandkit_released_email',
    internal_notification: 'Brand Kit o entrega final disponible para el cliente.',
  },
  [CRM_PHASE_IDS.F11]: {
    phase: CRM_PHASE_IDS.F11,
    whatsapp_template: 'postventa_whatsapp',
    email_template: 'postventa_email',
    internal_notification: 'Postventa activada: satisfaccion, testimonio y seguimiento.',
  },
});

export function normalizeCrmPhaseId(value) {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return CRM_PHASE_BY_INDEX[value]?.id || null;
  }

  const raw = String(value ?? '').trim().toUpperCase();
  if (!raw) return null;

  if (/^\d+$/.test(raw)) {
    return CRM_PHASE_BY_INDEX[Number(raw)]?.id || null;
  }

  return CRM_PHASES[raw]?.id || null;
}

export function getCrmPhase(value) {
  const phaseId = normalizeCrmPhaseId(value);
  return phaseId ? CRM_PHASES[phaseId] : null;
}

export function getCrmPhaseIndex(value, fallback = 0) {
  const phase = getCrmPhase(value);
  return phase ? phase.index : fallback;
}

export function getCrmAllowedNextPhases(value) {
  const phaseId = normalizeCrmPhaseId(value);
  return (CRM_ALLOWED_TRANSITIONS[phaseId] || []).map(id => CRM_PHASES[id]).filter(Boolean);
}

export function getCrmTransitionTrigger(nextPhase) {
  const phaseId = normalizeCrmPhaseId(nextPhase);
  return phaseId ? CRM_TRANSITION_TRIGGERS[phaseId] || null : null;
}

export function isCrmTransitionAllowed(fromPhase, toPhase, options = {}) {
  const fromId = normalizeCrmPhaseId(fromPhase);
  const toId = normalizeCrmPhaseId(toPhase);
  if (!fromId || !toId) return false;
  if (fromId === toId) return true;

  const from = CRM_PHASES[fromId];
  const to = CRM_PHASES[toId];
  if (!from || !to) return false;

  if (options.allowOverride === true) return true;
  if (options.allowBackwards === true && to.index < from.index) return true;

  return (CRM_ALLOWED_TRANSITIONS[fromId] || []).includes(toId);
}

export function assertCrmTransitionAllowed(fromPhase, toPhase, options = {}) {
  if (isCrmTransitionAllowed(fromPhase, toPhase, options)) {
    return { ok: true, from: getCrmPhase(fromPhase), to: getCrmPhase(toPhase) };
  }

  const from = getCrmPhase(fromPhase);
  const to = getCrmPhase(toPhase);
  const fromLabel = from?.label || String(fromPhase ?? 'sin fase');
  const toLabel = to?.label || String(toPhase ?? 'sin fase');

  return {
    ok: false,
    from,
    to,
    error: `Transicion CRM no permitida: ${fromLabel} -> ${toLabel}.`,
  };
}

// Alias explícito para los sitios que interpretan historia previa al corte.
// Nombrarlo así evita que alguien lo tome por la enumeración vigente.
export const LEGACY_CRM_PHASES_V1 = CRM_PHASES;
